// Small helpers to format notification title and details in a consistent way
export function formatNotificationTitle(notification: any) {
  const title = (notification?.title || '').toString();
  const event = (notification?.event || '').toString();
  const containsEvent = event && title.toLowerCase().includes(event.toLowerCase());
  if (notification?.title && !/^Audit\s*\d+$/i.test(title) && !containsEvent) return notification.title;

  const auditName = notification?.message?.split(':')[0] || notification?.audit_name || 'Audit';
  const actor = notification?.actor_name;
  const home = notification?.home_name;

  switch (event) {
    case 'audit_for_review':
      return `${auditName}: Completed by ${actor || 'staff'} For Review`;
    case 'audit_assignment':
    case 'audit_assigned':
      return `${auditName} assigned to you by ${actor || home || 'a manager'}`;
    case 'audit_approved':
      return `${auditName}: Approved`;
    case 'audit_reopened':
      return `${auditName}: Reopened`;
    default:
      return auditName;
  }
}

export function formatNotificationDetails(notification: any) {
  const parts: string[] = [];
  // Do not include the created_at date here — the UI renders created_at separately to avoid duplicate dates
  if (notification?.actor_name) parts.push(`by ${notification.actor_name}`);
  if (notification?.home_name && !notification?.actor_name) parts.push(notification.home_name);
  if (notification?.status) parts.push(`Status: ${notification.status}`);
  return parts.join(' — ');
}
